import React from 'react';

import { SvgCalendar } from '../../icons/v2';
import { View } from '../common/View';

import { useBudgetMonthCount } from './BudgetMonthCountContext';
import { Select } from "../common/Select";

type CalendarProps = {
  color: string;
  onClick: () => void;
};

function Calendar({ color, onClick }: CalendarProps) {
  return (
    <SvgCalendar
      style={{ width: 13, height: 13, color, marginRight: 5 }}
      onClick={onClick}
    />
  );
}

type MonthCountSelectorProps = {
  maxMonths: number;
  onChange: (value: number) => void;
};

export function MonthCountSelector({
                                     maxMonths,
                                     onChange,
                                   }: MonthCountSelectorProps) {
  const { displayMax } = useBudgetMonthCount();

  // It doesn't make sense to show anything if we can only fit one
  // month
  if (displayMax <= 1) {
    return null;
  }

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 20,
        gap: 10,
        WebkitAppRegion: 'no-drag',
        '& svg': {
          transition: 'transform .15s',
        },
        '& svg:hover': {
          transform: 'scale(1.2)',
        },
      }}
      title="Choose the number of months shown at a time"
    >
      <label>Date range: </label>
      <Select options={[['1', '1 month'], ['3', '3 months']]}
              value={`${maxMonths}`}
              onChange={option => {
                onChange(+option)
              }}/>
    </View>
  );
}
